import Vue from 'vue';
import axios from "axios";
import router from "@/router/index";
import Swal from 'sweetalert2';
import actions_token from "@/plugins/http/actions_token/actions_token.js";

let config = {
    baseURL: "",
    timeout: 60 * 6000, // Timeout
};

const http = axios.create(config);

http.interceptors.request.use(
    async function (config) {
        const tokenStorage = JSON.parse(sessionStorage.getItem("token"));
        const _expirado = actions_token._validarTiempoExpiracionToken(tokenStorage);
        const token = _expirado ? await actions_token._refreshToken(tokenStorage.refresh_token) : tokenStorage;

        return actions_token._setHeaders(config, token);

    },
    function (error) {
        // Do something with request error
        console.error('error al crear request', error);
        return Promise.reject(error);
    }
);

// Add a response interceptor
http.interceptors.response.use(
    response => {
        if (response.status === 200 || response.status === 201 || response.status ===206) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        switch (error?.response?.status) {
            case 400:
                Swal.fire({
                    icon: 'error',
                    title: 'ERROR',
                    text: error.response.data.payload.message,
                    confirmButtonColor: '#6E17A5'
                });
                break;
            case 401:
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'ERROR',
                        text: error.response.data.message,
                        confirmButtonColor: '#6E17A5'
                    });
                    if (router.app._route.fullPath !== '/login') {
                        router.push('/login')
                    }
                    break;
                }
            case 403:
                router.replace({
                    path: "/login",
                    query: { redirect: router.currentRoute.fullPath }
                });
                break;
            case 404:
                Swal.fire({
                    icon: 'error',
                    title: 'ERROR',
                    text: error.response.data.payload.message,
                    confirmButtonColor: '#6E17A5'
                });
                break;
            case 500:
                Swal.fire({
                    icon: 'error',
                    title: 'ERROR',
                    text: error.response.data.payload.message,
                    confirmButtonColor: '#6E17A5'
                });
                break;
            case 502:
                setTimeout(() => {
                    router.replace({
                        path: "/login",
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                }, 1000);
                break;
        }
        return error?.response ?
            Promise.reject(error?.response || error.message)
            : Swal.fire({
                icon: 'error',
                title: 'ERROR',
                text: 'Lo sentimos, nuestro equipo esta trabajando en mejoras vuelve pronto',
                showConfirmButton: false,
                timer: 2500,
                
            }).then(() => {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('idGroup');
                sessionStorage.removeItem('idUsuario');
                sessionStorage.removeItem('idEmpresa');
                router.push('/login')
            
                } 
            );
    }
);



Vue.prototype.$axios = http;

export default http;